import { CoreIcon } from '../core-icon';
import checkSVG from '../../assets/icons/check.svg';
import type { IconProps } from '../core-icon';

export const CheckIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={checkSVG} {...props} />;
};
